"use strict";

var _interopRequireDefault = require("/app/node_modules/.pnpm/@babel+runtime@7.25.6/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _default = exports.default = {
  name: 'YsYearRange',
  props: {
    value: {
      type: Array,
      default: () => [undefined, undefined]
    },
    format: {
      type: String,
      default: 'YYYY'
    },
    valueFormat: {
      type: String
    },
    allowClear: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      selectRange: [undefined, undefined],
      startOpen: false,
      endOpen: false
    };
  },
  watch: {
    value: {
      handler(value) {
        this.selectRange = value.map(item => item ? (0, _moment.default)(item) : undefined);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    moment: _moment.default,
    handleYearRangeStartPanelChange(value) {
      this.selectRange = [value, undefined];
      this.startOpen = false;
      this.endOpen = true;
    },
    handleYearRangeEndPanelChange(value) {
      this.selectRange[1] = value;
      this.updateModelValue();
      this.endOpen = false;
    },
    disabledEndDate(endValue) {
      const startValue = this.selectRange[0];
      if (!endValue || !startValue) {
        return false;
      }
      return endValue.valueOf() < startValue.valueOf();
    },
    handleStartOpenChange(open) {
      this.startOpen = open;
    },
    handleEndOpenChange(open) {
      if (open && !this.selectRange[0]) {
        this.startOpen = true;
        return;
      }
      if (!open && !this.selectRange[1]) {
        this.selectRange = this.value.map(item => item ? (0, _moment.default)(item) : undefined);
      }
      this.endOpen = open;
    },
    handleClear() {
      this.selectRange = [undefined, undefined];
      this.updateModelValue();
    },
    updateModelValue() {
      this.$emit('input', this.selectRange.map(item => item ? (0, _moment.default)(item).format(this.valueFormat || 'YYYY') : undefined));
    }
  }
};